import { Controller } from "@hotwired/stimulus"

export default class ShowMoreController extends Controller {
  showMore() {
    fetch(this.element.dataset.url, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
    .then(r => r.text())
    .then(html => Turbo.renderStreamMessage(html))
  }
}
